import { render, staticRenderFns } from "./approveFinish.vue?vue&type=template&id=ebc5451a&scoped=true"
import script from "./approveFinish.vue?vue&type=script&lang=ts"
export * from "./approveFinish.vue?vue&type=script&lang=ts"
import style0 from "./approveFinish.vue?vue&type=style&index=0&id=ebc5451a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc5451a",
  null
  
)

export default component.exports